<template lang="pug">
  div.img-viewer
    div.img(@click="$emit('close')")
      img(:src="img")
</template>

<script>
export default {
  name: 'ImgViewer',
  props: ['img']
}
</script>

<style lang="scss" scoped>
  .img-viewer{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 90;
    .img{
      cursor: pointer;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    img{
      height: 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/components/ImgViewer.vue